import { render, staticRenderFns } from "./PricingSection.vue?vue&type=template&id=f2ef6390&scoped=true"
import script from "./PricingSection.vue?vue&type=script&lang=js"
export * from "./PricingSection.vue?vue&type=script&lang=js"
import style0 from "./PricingSection.vue?vue&type=style&index=0&id=f2ef6390&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ef6390",
  null
  
)

export default component.exports